import React, { forwardRef } from 'react';
import { Box, OutlinedInputProps, TextField } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { IBoxFormTextField } from 'src/components/profileComponents/FormTextField/types';
import { useStyles } from './styles';

export const BoxFormTextField = forwardRef<HTMLInputElement, IBoxFormTextField>(({
  label,
  name,
  value,
  defaultValue,
  inputRef,
  startAdornment,
  placeholder,
  onChange,
  onBlur,
  errors,
  ...props
}, ref) => {
  const styles = useStyles();
  return (
    <Box mb={6} width="100%" display="flex" flexDirection="column">
      { label && (
        <Box mb={2} className="label">
          { label }
        </Box>
      ) }
      <Box className={`${styles.wrapper} text-field-wrapper`}>
        { !startAdornment && (
          <>
            <TextField
              ref={ref}
              id={name}
              name={name}
              variant="outlined"
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              inputRef={inputRef}
              onChange={onChange}
              onBlur={onBlur}
              {...props}
            />
            {errors && name && errors[name] && (
              <Box className={`${styles.error}`}>
                {errors[name].message}
              </Box>
            )}
          </>
        ) }
        { startAdornment && (
          <>
            <OutlinedInput
              fullWidth
              startAdornment={startAdornment}
              value={value}
              defaultValue={defaultValue}
              placeholder={placeholder}
              name={name}
              inputRef={inputRef}
              onChange={onChange}
              onBlur={onBlur}
              {...props as OutlinedInputProps}
            />
            {errors && name && errors[name] && (
              <Box className={`${styles.error}`}>
                {errors[name].message}
              </Box>
            )}
          </>
        ) }
      </Box>
    </Box>
  );
});
